import React, { useContext, useEffect, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import {
  Table, Space, Popconfirm, Button, Input,
} from 'antd';
import moment from 'moment';

import { VerticalContainer } from '../../../components/styled';
import { UserContext } from '../../../context';
import history from '../../../routes/history';
import { deleteDistrict, getDistricts } from '../../../services/districts';
import AddDistrict from '../add';

const { Search } = Input;

const { Column } = Table;
export default function ListDistricts() {
  const [visibleAddDistrict, setVisibleAddDistrict] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');
  const [districts, setDistricts] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);
  const user = useContext(UserContext);
  const getDistrictsPaginated = async () => {
    try {
      setLoading(true);
      const districtsData = await getDistricts(page, filter);
      setDistricts(districtsData.data);
      setTotal(districtsData.total);
    } finally {
      setLoading(false);
    }
  };
  const onConfirm = async () => {
    await getDistrictsPaginated();
  };

  useEffect(() => {
    getDistrictsPaginated();
  }, [page, filter]);

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
  };

  async function confirm(record) {
    await deleteDistrict(record.id);
    await getDistrictsPaginated();
  }

  function cancel(e) {
    console.log(e);
  }
  const onSearch = (value) => {
    setFilter(value);
  };
  const onChange = (e) => {
    if (!e.target.value) setFilter('');
  };

  return (
    <>
      <VerticalContainer>
        <Search
          onChange={onChange}
          style={{ width: '50%' }}
          placeholder="Pesquisar distrito"
          enterButton="Pesquisar"
          onSearch={onSearch}
          size="middle"
        />
        <br />
        <Button
          type="dashed"
          onClick={() => {
            setVisibleAddDistrict(true);
          }}
          style={{ width: '100%!important' }}
          block
        >
          <PlusOutlined />
          Adicionar distrito
        </Button>
        <br />
        <Table
          size="middle"
          pagination={{ pageSize: 10, total }}
          onChange={handleTableChange}
          style={{
            width: '100%',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
          }}
          dataSource={districts}
          rowKey="id"
          loading={loading}
        >
          <Column width="10%" title="Código" dataIndex="id" key="id" />
          <Column width="10%" title="Cód. Distrito" dataIndex="codigo" key="codigo" />
          <Column width="15%" title="Nome" dataIndex="nome" key="nome" />

          <Column
            width="15%"
            title="Data de criação"
            dataIndex="created_at"
            render={(data) => moment(data).format('DD/MM/YYYY')}
            key="created_at"
          />
          <Column
            width="20%"
            title="Ação"
            key="action"
            render={(text, record) => (
              <Space size="middle">
                <a onClick={() => history.push(`distritos/${record.id}`)}>Visualizar</a>
                {user?.type === 'ADM'
                && (
                <Popconfirm
                  title="Deseja deletar o distrito?"
                  onConfirm={() => confirm(record)}
                  onCancel={cancel}
                  okText="Sim"
                  cancelText="Não"
                >
                  <a>Deletar</a>
                </Popconfirm>
                )}
              </Space>
            )}
          />
        </Table>
        {visibleAddDistrict ? (
          <AddDistrict
            visible={visibleAddDistrict}
            setVisible={setVisibleAddDistrict}
            onConfirm={onConfirm}
          />
        ) : (
          ''
        )}
      </VerticalContainer>
    </>
  );
}
